import React from "react";
import { useSelector } from "react-redux";
import anvisaLogo from '../../assets/images/anvisa-logo.png';
import compraSeguraBlindado from "../../assets/images/comprasegura-blindado.png";
import compraSeguraGoogle from "../../assets/images/comprasegura-google.png";
import compraSeguraNorton from "../../assets/images/comprasegura-norton.png";
import packageJson from "../../../package.json";
import {
  RodapeWrapper,
  Zona1Grid,
  LogoCol,
  GrupoCol,
  Zona2Bar,
  PagamentoChip,
  Zona3Legal,
} from "./styles";
import { logoRodape, erroLogo } from "../../util/logoLoja";

export default function RodapeIdentidadeVisual() {
  const { data: identidade } = useSelector(state => state.identidadeVisual);
  const empresa = useSelector(state => state.store.data?.empresa);
  const cores = identidade?.cores || {};
  const descricao_site = identidade?.descricao_site;
  const rodape_grupos = identidade?.rodape_grupos || [];
  const rodape_pagamentos = identidade?.rodape_pagamentos || [];
  const rodape_aviso_legal = identidade?.rodape_aviso_legal;

  const logoUrl = logoRodape(identidade, empresa);

  const nome = empresa?.nome || descricao_site;
  const totalColunas = rodape_grupos.length;

  return (
    <RodapeWrapper fundo={cores.rodape_fundo} texto={cores.rodape_texto}>
      {/* ZONA 1 — grid principal */}
      <Zona1Grid colunas={totalColunas}>
        <LogoCol>
          {logoUrl && <img src={logoUrl} alt={nome || "Logo"} onError={erroLogo} />}
          {descricao_site && <p className="tagline">{descricao_site}</p>}
        </LogoCol>

        {rodape_grupos.map((grupo, idx) => (
          <React.Fragment key={idx}>
            {idx % 4 === 0 && idx !== 0 && <GrupoCol />}
            <GrupoCol>
              <h4>{grupo.titulo}</h4>
              <ul>
                {(grupo.itens || []).map((item, i) => (
                  <li key={i}>
                    {item.tipo === "texto" && <span>{item.label}</span>}
                    {item.tipo === "link" && (
                      <a
                        href={item.url}
                        target={item.nova_aba ? "_blank" : undefined}
                        rel="noopener noreferrer"
                      >
                        {item.label}
                      </a>
                    )}
                    {item.tipo === "pagina" && (
                      <a href={item.url}>{item.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </GrupoCol>
          </React.Fragment>
        ))}
      </Zona1Grid>

      {/* ZONA 2 — copyright e pagamentos */}
      <Zona2Bar>
        <div className="zonaContent">
          <span className="copyright">
            &copy; {new Date().getFullYear()} {nome} &mdash; Todos os direitos
            reservados &middot; v{packageJson.version}
          </span>
          {rodape_pagamentos.length > 0 && (
            <div className="pagamentos">
              <span className="label">Pagamentos:</span>
              {rodape_pagamentos.map((pag, idx) => (
                <PagamentoChip key={idx}>
                  {typeof pag === "string" ? pag : pag.label}
                </PagamentoChip>
              ))}
            </div>
          )}
        </div>
      </Zona2Bar>

      {/* ZONA 3 — aviso legal */}
      <Zona3Legal>
        <div className="zonaContent">
          {rodape_aviso_legal && (
            <div
              className="legal-text"
              dangerouslySetInnerHTML={{ __html: rodape_aviso_legal }}
            />
          )}
          <div className="anvisa-row">
            <ul className="selos">
              {/* <li>
                <img src={compraSeguraGoogle} alt="Compra segura" />
              </li> */}
              <li>
                <img src={compraSeguraBlindado} alt="Compra segura" />
              </li>
              <li>
                <img src={compraSeguraNorton} alt="Compra segura" />
              </li>
            </ul>
            <a
              href="https://www.anvisa.gov.br"
              target="_blank"
              rel="noopener noreferrer"
            >
              A rede segue as determinações da
              <img
                src={anvisaLogo}
                alt="ANVISA"
              />
            </a>
          </div>
        </div>
      </Zona3Legal>
    </RodapeWrapper>
  );
}
